import {ShapeCommand} from '../commands.template';
import {AttachmentType} from '@q9elements/ui-kit/common';

export class ActivityDeleteAttachmentCommand extends ShapeCommand {
  services: any;
  firstAction: boolean;
  mxKey: number;
  constructor(data) {
    super(data);
    this.firstAction = true;
  }

  public execute() {
    let action;
    const param = {
      itemMxKey: this.object.itemMxKey,
      mxKey: this.object.mxKey
    };

    if (this.object.refModel) {
      action = {deleteRefModelAttachment: param};
    } else if (this.object.requirement) {
      action = {deleteRequirementAttachment: param};

      return this.removeStoryOrRequirement(action, 'requirement');
    } else if (this.object.story) {
      action = {deleteStoryAttachment: param};

      return this.removeStoryOrRequirement(action, 'story');
    } else if (this.object.sfNode) {
      action = {deleteOrgModelAttachment: param};
    } else {
      action = {deleteAttachment: param};
    }

    const isUrlAttachment =
      this.object.type === AttachmentType.URL || this.object.type === AttachmentType.URL_ENTRY;

    if (isUrlAttachment) {
      return this.services.diagramUpdateSvc.update(action, true, isUrlAttachment).then(() => {
        this.services.jsonHandlerSvc.update(action);
      });
    }

    return this.services.diagramUpdateSvc.update(action).then(result => {
      this.redrawActivity(this.object.itemMxKey);

      return result;
    });
  }

  public reverse() {
    let action;
    const param = {
      mxKey: this.object.mxKey,
      type: this.object.type,
      itemMxKey: this.object.itemMxKey,
      refModel: this.object.refModel,
      refModelNode: this.object.refModelNode,
      sfNode: this.object.sfNode,
      description: this.object.description,
      groups: this.object.groups,
      title: this.object.title,
      value: this.object.value,
      dataStructureDefinition: this.object.dataStructureDefinition,
      refModelName: this.object.refModelName,
      nodePath: this.object.nodePath,
      externalUrl: this.object.externalUrl,
      linkType: this.object.linkType,
      lightningExternalUrl: this.object.lightningExternalUrl,
      requirement: this.object.requirement,
      reqId: this.object.reqId,
      reqReason: this.object.reqReason,
      reqDetails: this.object.reqDetails,
      savedOnS3: this.object.savedOnS3,
      needToRestore: this.object.savedOnS3 && this.object.type === 'text',
      displayInUserHelp: this.object.displayInUserHelp,
      displayInUserHelpClassic: this.object.displayInUserHelpClassic,
      pushedAsSfHelpDate: this.object.pushedAsSfHelpDate,

      story: this.object.story,
      storyId: this.object.storyId,
      urlEntry: this.object.urlEntry
    };

    if (this.object.refModel) {
      action = {createRefModelAttachment: param};
    } else if (this.object.requirement) {
      action = {createRequirementAttachment: param};

      return this.removeStoryOrRequirement(action, 'requirement', true);
    } else if (this.object.story) {
      action = {createStoryAttachment: param};

      return this.removeStoryOrRequirement(action, 'story', true);
    } else if (this.object.sfNode) {
      action = {createOrgModelAttachment: param};
    } else {
      action = {createAttachment: param};
    }

    return this.services.diagramUpdateSvc.update(action).then(result => {
      this.redrawActivity(this.object.itemMxKey);

      return result;
    });
  }

  private removeStoryOrRequirement(action, type: 'story' | 'requirement', undo?: boolean) {
    if (undo) {
      const [actionType] = Object.keys(action);

      action[actionType][type] = action[actionType][type].id;
    }

    return this.services.diagramUpdateSvc.update(action, true, true).then(result => {
      this.services.jsonHandlerSvc.update(action);
      this.redrawActivity(this.object.itemMxKey);

      return result;
    });
  }

  private redrawActivity(mxKey) {
    this.services.editorRegistrySvc
      .getGraph()
      .model.getCell(Number(mxKey))
      .comp.instance.setupFromJson();
  }
}
